/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * The SKY API
 * OpenAPI spec version: 1.0.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  BadRequestResponse,
  ForbiddenResponse,
  GetAnalyticsDashboard200,
  GetAnalyticsDashboardParams,
  GetAnalyticsProductivity200,
  GetAnalyticsProductivityParams,
  InternalServerErrorResponse,
  NotFoundResponse,
  UnauthorizedResponse
} from '../model';

import { customInstance } from '../../custom-instance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary Retrieve analytics dashboard data for an organization
 */
export const getAnalyticsDashboard = (
    organizationId: string,
    params?: GetAnalyticsDashboardParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<GetAnalyticsDashboard200>(
      {url: `https://api.app.sky-tech.ai/organizations/${organizationId}/analytics/dashboard`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetAnalyticsDashboardQueryKey = (organizationId: string,
    params?: GetAnalyticsDashboardParams,) => {
    return [
    `https://api.app.sky-tech.ai/organizations/${organizationId}/analytics/dashboard`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetAnalyticsDashboardQueryOptions = <TData = Awaited<ReturnType<typeof getAnalyticsDashboard>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(organizationId: string,
    params?: GetAnalyticsDashboardParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsDashboard>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAnalyticsDashboardQueryKey(organizationId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAnalyticsDashboard>>> = ({ signal }) => getAnalyticsDashboard(organizationId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: organizationId !== null && organizationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsDashboard>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAnalyticsDashboardQueryResult = NonNullable<Awaited<ReturnType<typeof getAnalyticsDashboard>>>
export type GetAnalyticsDashboardQueryError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse


export function useGetAnalyticsDashboard<TData = Awaited<ReturnType<typeof getAnalyticsDashboard>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(
 organizationId: string,
    params: undefined |  GetAnalyticsDashboardParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsDashboard>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAnalyticsDashboard>>,
          TError,
          Awaited<ReturnType<typeof getAnalyticsDashboard>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAnalyticsDashboard<TData = Awaited<ReturnType<typeof getAnalyticsDashboard>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(
 organizationId: string,
    params?: GetAnalyticsDashboardParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsDashboard>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAnalyticsDashboard>>,
          TError,
          Awaited<ReturnType<typeof getAnalyticsDashboard>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAnalyticsDashboard<TData = Awaited<ReturnType<typeof getAnalyticsDashboard>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(
 organizationId: string,
    params?: GetAnalyticsDashboardParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsDashboard>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieve analytics dashboard data for an organization
 */

export function useGetAnalyticsDashboard<TData = Awaited<ReturnType<typeof getAnalyticsDashboard>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(
 organizationId: string,
    params?: GetAnalyticsDashboardParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsDashboard>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAnalyticsDashboardQueryOptions(organizationId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Retrieve team productivity analytics for an organization
 */
export const getAnalyticsProductivity = (
    organizationId: string,
    params?: GetAnalyticsProductivityParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<GetAnalyticsProductivity200>(
      {url: `https://api.app.sky-tech.ai/organizations/${organizationId}/analytics/productivity`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetAnalyticsProductivityQueryKey = (organizationId: string,
    params?: GetAnalyticsProductivityParams,) => {
    return [
    `https://api.app.sky-tech.ai/organizations/${organizationId}/analytics/productivity`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetAnalyticsProductivityQueryOptions = <TData = Awaited<ReturnType<typeof getAnalyticsProductivity>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(organizationId: string,
    params?: GetAnalyticsProductivityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsProductivity>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAnalyticsProductivityQueryKey(organizationId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAnalyticsProductivity>>> = ({ signal }) => getAnalyticsProductivity(organizationId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: organizationId !== null && organizationId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsProductivity>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAnalyticsProductivityQueryResult = NonNullable<Awaited<ReturnType<typeof getAnalyticsProductivity>>>
export type GetAnalyticsProductivityQueryError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse


export function useGetAnalyticsProductivity<TData = Awaited<ReturnType<typeof getAnalyticsProductivity>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(
 organizationId: string,
    params: undefined |  GetAnalyticsProductivityParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsProductivity>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAnalyticsProductivity>>,
          TError,
          Awaited<ReturnType<typeof getAnalyticsProductivity>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAnalyticsProductivity<TData = Awaited<ReturnType<typeof getAnalyticsProductivity>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(
 organizationId: string,
    params?: GetAnalyticsProductivityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsProductivity>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAnalyticsProductivity>>,
          TError,
          Awaited<ReturnType<typeof getAnalyticsProductivity>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAnalyticsProductivity<TData = Awaited<ReturnType<typeof getAnalyticsProductivity>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(
 organizationId: string,
    params?: GetAnalyticsProductivityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsProductivity>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieve team productivity analytics for an organization
 */

export function useGetAnalyticsProductivity<TData = Awaited<ReturnType<typeof getAnalyticsProductivity>>, TError = BadRequestResponse | UnauthorizedResponse | ForbiddenResponse | NotFoundResponse | InternalServerErrorResponse>(
 organizationId: string,
    params?: GetAnalyticsProductivityParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsProductivity>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAnalyticsProductivityQueryOptions(organizationId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






